import {
    forwardRef,
    useImperativeHandle,
    useState,
    ReactNode,
  } from "react";
  import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    DialogProps,
  } from "@mui/material";
  
  export interface TableDialogPayload {
    title?: ReactNode;
    content: ReactNode;
    actions?: ReactNode;
    dialogProps?: Partial<DialogProps>;
  }
  
  export interface TableDialogHandle {
    open: (p: TableDialogPayload) => void;
    update: (patch: Partial<TableDialogPayload>) => void;
    close: () => void;
  }
  
  export const TableDialog = forwardRef<TableDialogHandle>((_, ref) => {
    const [state, set] = useState<TableDialogPayload & { open: boolean }>({
      content: null,
      title: "",
      actions: null,
      dialogProps: {},
      open: false,
    });
  
    useImperativeHandle(ref, () => ({
      open: (p) => set({ ...p, open: true }),
      update: (patch) => set((s) => ({ ...s, ...patch })),
      close: () => set((s) => ({ ...s, open: false })),
    }));
  
    const { title, content, actions, dialogProps, open } = state;
  
    return (
      <Dialog
        open={open}
        onClose={() => set((s) => ({ ...s, open: false }))}
        maxWidth={false}
        fullWidth
        PaperProps={{ sx: { width: "90vw", height: "90vh" } }}
        scroll="paper"
        {...dialogProps}
      >
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent dividers sx={{ p: 0 }}>{content}</DialogContent>
        <DialogActions>
          {actions}
          <Button onClick={() => set((s) => ({ ...s, open: false }))}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  });
  